<template>
  <div id="qrcode">
    <h4 class="w-full mt-4 md:mt-12 p-3 pl-1">QrCodes</h4>
    <vs-row vs-w="12">
      <vs-col vs-sm="12" vs-lg="12" class="p-2">
        <div>
          <!-- qrcode name -->
          <DataInput
            v-model="qrCodeInput.name"
            type="text"
            label="Name *"
            name="name"
            class="mb-4"
          />
          <!-- ausprägung/druckgegenstand -->
          <DataInput
            v-model="qrCodeInput.variant_id"
            type="model"
            label="Ausprägung *"
            name="qrCodeVariants"
            gql-query="qrCodeVariants"
            :gql-query-attributes="`page: 1, search: $search`"
            allow-null
            class="mb-4"
          />
          <!-- kampagne -->
          <DataInput
            v-model="qrCodeInput.ad_campaign_id"
            type="model"
            name="campaign"
            label="Kampagne"
            model-label="name"
            gql-query="adCampaigns"
            gql-filter-type="objectFilter"
            object-filter-attribute="search"
            allow-null
          />
        </div>
      </vs-col>
      <vs-col vs-sm="12" vs-lg="12" class="pr-2 pt-4 text-right">
        <vs-button @click="submit()"> Generieren & Downloaden </vs-button>
      </vs-col>

      <vs-col vs-sm="12" vs-lg="12" class="p-4"> </vs-col>
    </vs-row>
    <table
      v-if="qrCodes && qrCodes.results && qrCodes.results.length"
      class="mb-4"
    >
      <thead>
        <tr>
          <th>Name</th>
          <th>Ausprägung</th>
          <th>Kampagne</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="qrCode in qrCodes.results" :key="qrCode.id">
          <td>
            {{ qrCode.name }}
          </td>
          <td>{{ qrCode.variant.name }}</td>
          <td>
            <router-link
              v-if="qrCode.ad_campaign"
              :to="{
                name: 'bi.campaigns.edit',
                params: { id: qrCode.ad_campaign.id }
              }"
            >
              {{ qrCode.ad_campaign.name }}
            </router-link>
          </td>
          <td class="qr-download-col">
            <span
              class="cursor-pointer"
              @click="downloadQr(qrCode.id, qrCode.name)"
            >
              <i class="far fa-download"></i>
            </span>
            <!-- canvas must exist in order to download image -->
            <qrcode
              :id="qrCode.id"
              :value="`https://qr.select-gmbh.de?id=${qrCode.id}`"
              :options="{ width: 4000 }"
              style="display: none"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <div style="background: pink">
      form
      <pre>{{ qrCodeInput }}</pre>
    </div>
    <div style="background: lightblue">
      props<br />
      vacancy
      <pre>{{ vacancy }}</pre>
    </div>
    <div style="background: lightgrey">
      existing codes
      <pre>{{ qrCodes }}</pre>
    </div> -->
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  props: {
    vacancy: { type: Object, required: true }
  },
  data: () => ({
    qrCodeInput: {
      name: null,
      ad_campaign_id: null,
      user_group_id: null,
      variant_id: null,
      base_url: null,
      vacancy_id: null
    }
  }),
  computed: {
    slugifiedUrl() {
      let str = this.vacancy.title;
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "ßàáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "saaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      str = `https://www.select-gmbh.de/stelle/${str}/${this.vacancy.number}`;

      return str;
    }
  },
  apollo: {
    qrCodes: {
      query: gql`
        query QrCodes($filter: QrCodeFilter!) {
          qrCodes(filter: $filter) {
            total
            results {
              id
              name
              qr_url
              variant {
                id
                name
              }
              vacancy {
                id
                title
              }
              user_group {
                id
                name
              }
              ad_campaign {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            vacancy_id: this.vacancy.id
          },
          size: 1000000
        };
      }
    }
  },
  watch: {
    vacancy: {
      deep: true,
      handler: function() {
        this.qrCodeInput.vacancy_id = this.vacancy.id;
        this.qrCodeInput.user_group_id = this.vacancy.project.userGroup.id;
        this.qrCodeInput.base_url = this.slugifiedUrl;
      }
    }
  },
  mounted() {
    this.qrCodeInput.base_url = this.slugifiedUrl;
    this.qrCodeInput.vacancy_id = this.vacancy.id;
    this.qrCodeInput.user_group_id = this.vacancy.project.userGroup.id;
  },
  methods: {
    async submit() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation QrCodeCreate($input: QrCodeInput!) {
              qrCodeCreate(input: $input) {
                id
                name
                base_url
                qr_url
                user_group_id
                variant_id
                ad_campaign_id
              }
            }
          `,
          variables: {
            input: this.qrCodeInput
          }
        })
        .then(({ data }) => {
          // reset form
          this.qrCodeInput.name = null;
          this.qrCodeInput.ad_campaign_id = null;
          this.qrCodeInput.variant_id = null;
          //refetch qr codes
          this.$apollo.queries.qrCodes.refetch().then(() => {
            // download new qrcode
            this.downloadQr(data.qrCodeCreate.id, data.qrCodeCreate.name);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadQr(id, name) {
      var link = document.createElement("a");
      link.download = name + ".png";
      link.href = document.getElementById(id).toDataURL();
      link.click();
    }
  }
};
</script>

<style scoped>
.qr-download-col {
  text-align: end;
}
td {
  padding: 1rem;
  /* padding-bottom: 0; */
  opacity: 0.8;
}
tr + tr {
  border-top: 1px solid lightgray;
}
th {
  padding: 1rem;
  padding-bottom: 0;
  font-size: 1.125rem;
  font-weight: 400;
}
h4 {
  margin-left: 0.5rem;
}
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
